import './lib/polyfill';
import Dispatcher from 'a-dispatcher';
import domContentLoaded from 'dom-content-loaded';
import FoldMenu from 'fold-menu';
import lazyHover from 'lazy-hover';
import fonts from './fonts';
import FakeScroll from './lib/fake-scroll';
import './old/lib/autoStick.js';
import schedule from './old/pages/admission_schedule.js';
import scheduleEntry from './old/pages/admission_schedule_entry.js';
import request from './old/pages/request.js';
import request2017 from './old/pages/request2017.js';
import formKana from './formKana.js';
import formCheck from './formCheck.js';

import admin from './admin.js';
import $ from 'jquery';
// import 'slick-carousel';

import { debounce } from 'throttle-debounce';
import initContent from './initContent';

/**
 * スタイルの読み込み
 */
import '../scss/site.scss';

/**
 * FontAwesome 5
 */
fonts();

/**
 * Load
 */
window.addEventListener('load', () => { });

/**
 * Dispatcher
 */
const dispatcher = new Dispatcher();

// 必要かわからないので保留
// dispatcher.addRoute("^/admission/$",async () => {
//   const { default: admissionTop } = await import(/* webpackChunkName: "admission_top" */"./old/pages/admission_top.js");
//   admissionTop();
// });

dispatcher.addRoute("^/program/essentials/$", async () => {
    const { default: essentials } = await import(/* webpackChunkName: "essentials" */"./essentials.js");
    essentials();
});

dispatcher.addRoute("^/program/essentials/signup/$|/program/essentials/cart/", async () => {
    const { default: formKana } = await import(/* webpackChunkName: "formKana" */"./formKana.js");
    const { default: formZipcode } = await import(/* webpackChunkName: "formZipcode" */"./formZipcode.js");
    formKana();
    formZipcode();
});

dispatcher.addRoute("^/program/essentials/en/$", async () => {
    const { default: essentials_en } = await import(/* webpackChunkName: "essentials" */"./essentials_en.js");
    essentials_en();
});

dispatcher.addRoute("^/case/document/|/en/case/document/", async () => {
    const { default: case_document } = await import(/* webpackChunkName: "case_document" */"./case_document.js");
    case_document();
});

// dispatcher.addRoute("^/case/document/$",async () => {
// 	const { default: apcc_case } = await import(/* webpackChunkName: "apcc_case" */"./apcc_case.js");
// 	apcc_case();
// });

dispatcher.addRoute("^/form-info-session/$", async () => {
    const { default: info_session } = await import(/* webpackChunkName: "info_session" */"./info_session.js");
    const { default: formKana } = await import(/* webpackChunkName: "formKana" */"./formKana.js");
    const { default: formCheck } = await import(/* webpackChunkName: "formCheck" */"./formCheck.js");
    info_session();
    formKana();
    formCheck();
});

dispatcher.addRoute("^/en/form-info-session/$", async () => {
    const { default: info_session_en } = await import(/* webpackChunkName: "info_session_en" */"./info_session_en.js");
    const { default: formCheck } = await import(/* webpackChunkName: "formCheck" */"./formCheck.js");
    info_session_en();
    formCheck();
});

dispatcher.addRoute("^/form-open-seminar/$", async () => {
    const { default: formKana } = await import(/* webpackChunkName: "formKana" */"./formKana.js");
    const { default: formCheck } = await import(/* webpackChunkName: "formCheck" */"./formCheck.js");
    formKana();
    formCheck();
});

dispatcher.addRoute("^/en/form-open-seminar/$", async () => {
    const { default: formCheck } = await import(/* webpackChunkName: "formCheck" */"./formCheck.js");
    formCheck();
});

dispatcher.addRoute("^/admission/schedule/$", () => {
    schedule();
});

dispatcher.addRoute("^/admission/schedule/.+", () => {
    scheduleEntry();
});

dispatcher.addRoute("^/request.*/$", () => {
    request();
    request2017();
});

dispatcher.addRoute("^/request.*/$|^/contact/$|^/download/form.html|^/university/recruit/form/$", () => {
    formKana();
    formCheck();
});

dispatcher.addRoute("^/en/request/$|^/en/admission/download/form.html|^/en/contact/$", () => {
    $('.js-form-open-focus').focus();
    formCheck();
});

dispatcher.addRoute("app_sub_navigation|module_edit", () => {
    admin();
});


// MBA単科登録ページ用生年月日の年上限
// dispatcher.addRoute("^/program/essentials/login/alt/subscribe/.*", () => {

//   $customerBirthYear = $('select[name="customer_birth_year"]');

//   // 生年のセレクトメニューから不要なoptionを非表示にする
//   if($customerBirthYear.length > 0){
//     // defaultYearは今年から14年前
//     var now   = new Date();
//     var defaultYear  = now.getFullYear() - 14;

//     $('select[name="customer_birth_year"] > option').each(function(){

//       // defaultYearの前後5年間以外は削除
//       if($(this).val() < defaultYear - 7 || defaultYear + 6 < $(this).val() ){

//         // 値が入っているoptionだけ削除
//         if($(this).val()) {
//           $(this).remove();
//         }

//       }
//     })

//     // reapply時以外は初期値をselectedにする
//     // if(location.search !== '?step=reapply') {
//     //   $('select[name="customer_birth_year"] > option[value="' + defaultYear + '"]').prop('selected', true);
//     // }
//   }
// });

dispatcher.run(location.pathname);

/**
 * Content Ready
 */
domContentLoaded(() => {
    /**
     * htmxでswapしたときと共通のスクリプト
     */

    initContent();

    // モーダルからのリンクで?printがクエリとしてある場合にはプリントダイアログを開く

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('print')) {
        window.print();
        // ?print クエリパラメータを削除
        urlParams.delete('print');
        const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
        history.replaceState(null, '', newUrl);
    }

    /**
     * resize時にmodalBgのサイズを調整する
     */

    window.addEventListener(
        'resize', () => {
            const modalBg = document.querySelector('.modal-bg');
            const splitElements = document.querySelector('.p-split__elements');
            if (modalBg) {
                if (window.innerWidth >= 1024) {
                    // PCの場合
                    modalBg.style.width = window.getComputedStyle(splitElements).width;
                } else {
                    modalBg.style.width = '100%';
                }
            }
        }
    );

    /**
     * YouTube動画背景
     */
    const ytArea = 'video-background';
    const ytAreaDom = document.querySelector('#video-background');

    if (window.innerWidth >= 1024 && ytAreaDom) { // $breakpoint-lg-min
        const ytID = ytAreaDom.getAttribute('data-youtube-id');
        const ytListSwitch = ytAreaDom.getAttribute('data-youtube-list') ? ytAreaDom.getAttribute('data-youtube-list') : null;
        const ytSec = ytAreaDom.getAttribute('data-youtube-sec') ? ytAreaDom.getAttribute('data-youtube-sec') : 0;
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // 動画再生/停止ボタン用変数定義
        const videoSwitch = document.querySelector('.js-youtube-switch');
        let videoSwitchButton = videoSwitch.querySelector('button');
        const switchName = 'aria-checked';
        const pauseKey = 'YouTubePause';
        let firstLoadFlag = true;

        // 動画を画面いっぱいに&上下左右に出てくる黒帯を非表示
        const yt_screen_retio = () => {
            const ratio_H = $(window).height() / 0.5625;
            $('#video-background').css({
                'height': '100%',
                'width': ratio_H,
                'margin-top': '0',
                'margin-left': -ratio_H / 2,
                'left': '50%',
                'top': '0'
            });
        };

        // スクロール位置での動画停止用変数定義
        // const windowHeight = document.documentElement.clientHeight;
        // let scrollPauseVideo = false;

        // プレイヤーの埋め込み
        window.onYouTubeIframeAPIReady = () => {
            // youtube再生オプション設定
            const ytPlayerVars = {
                rel: 0, // 関連動画の非表示（0にすると関連動画は同じチャンネルから選ばれる）
                start: ytSec,   // スタート秒数
                controls: 0, // プレイヤーコントロールの非表示
                showinfo: 0, // タイトルなどの非表示
                modestbranding: 1, // YouTubeロゴの非表示
                iv_load_policy: 3, // アノテーションの非表示
                cc_load_policy: 0, // 字幕の非表示
                wmode: 'transparent'
            }
            const ytPlayerEvents = {
                'onReady': onPlayerReady, // iframe動画の準備が整った時
                'onStateChange': onPlayerStateChange // iframe動画の状態が変わった時
            }
            // 動画タイプ別にプレイヤー埋め込み
            if (ytListSwitch === 'true') {
                // 再生リストの場合
                ytPlayerVars.list = ytID;
                ytPlayerVars.listType = 'playlist';
                ytPlayerVars.loop = 1;
                ytPlayerVars.playlist = ytID;
                ytPlayer = new YT.Player(ytArea, {
                    playerVars: ytPlayerVars,
                    events: ytPlayerEvents,
                });
            } else {
                // 動画1本の場合
                ytPlayer = new YT.Player(ytArea, {
                    videoId: ytID,
                    playerVars: ytPlayerVars,
                    events: ytPlayerEvents,
                });
            }
        };

        // iframe動画の準備が整った時
        window.onPlayerReady = (e) => {
            ytPlayer.playVideo(); // 動画の再生
            ytPlayer.mute(); // 音消し
            ytPlayer.setPlaybackQuality('small'); // 画質指定(small・medium・large・hd720・hd1080・highres・default)

            // スクロールによる動画の一時停止
            // window.addEventListener(
            //     'scroll',
            //     throttle(1000, () => {
            //         if ( (scrollPauseVideo === false)
            //             && (ytPlayer.getPlayerState() === 1)
            //             && (document.documentElement.scrollTop > windowHeight)
            //         ) {
            //             ytPlayer.pauseVideo();
            //             scrollPauseVideo = true;
            //             // 動画が一時停止してなかったら止める & ボタンの状態を変更
            //             // if (videoSwitchButton.getAttribute(switchName) == 'true') {
            //                 // videoSwitchButton.setAttribute(switchName, 'false');
            //                 // ytPlayer.pauseVideo();
            //                 // sessionStorage.setItem(pauseKey, 'true');
            //             // }
            //         }
            //     }), { passive: true }
            // );
        };
        // リサイズが終了した時点で、動画を画面いっぱいに&上下左右に出てくる黒帯を非表示
        window.addEventListener(
            'resize',
            debounce(200, () => {
                yt_screen_retio();
            }), { passive: true }
        );

        // iframe動画の状態が変わった時
        window.onPlayerStateChange = (e) => {
            const ytStatus = e.target.getPlayerState();

            // 動画が再生中の状態
            if (ytStatus == YT.PlayerState.PLAYING) {
                yt_screen_retio();
                setTimeout(() => {
                    $('#video-background').addClass('active');
                }, 100);

                // ロード時初回再生時のみ処理する
                if (firstLoadFlag) {
                    // 動画を停止した状態でページ遷移した場合
                    if (sessionStorage.getItem(pauseKey)) {
                        videoSwitchButton.setAttribute(switchName, 'false');
                        ytPlayer.pauseVideo();
                        sessionStorage.setItem(pauseKey, 'false');
                    }
                    firstLoadFlag = false;
                    // スイッチの表記確定後表示
                    videoSwitch.classList.add('is-screen');
                }
            }

            //  動画の再生が終了した状態（一時停止した後にスタートすると一度ENDED状態を挟む）
            if (ytStatus == YT.PlayerState.ENDED) {
                // // ytPlayer.playVideo();
                ytPlayer.seekTo(ytSec, true);
                ytPlayer.mute();
                yt_screen_retio();
                videoSwitchButton.setAttribute(switchName, 'true');
            }
        };

        // 動画再生/停止ボタンによる一時停止
        videoSwitchButton.addEventListener('click', function () {
            if (videoSwitchButton.getAttribute(switchName) == 'true') {
                videoSwitchButton.setAttribute(switchName, 'false');
                ytPlayer.pauseVideo();
                sessionStorage.setItem(pauseKey, 'true');
            } else {
                videoSwitchButton.setAttribute(switchName, 'true');
                ytPlayer.playVideo();
                sessionStorage.removeItem(pauseKey);
            }
        });
    }

    if (document.querySelector('.js-search-btn')) {
        $('.js-search-btn').click(function () {
            $('.js-search-contents').slideToggle();
        });
        $('.js-fold-menu > ul > li').hover(function () {
            $('.js-search-contents').slideUp();
        })
    }

    if (document.querySelector('.js-nav-overlay-content')) {
        $('.js-nav-toggle').click(function () {
            $(this).find('.js-nav-btn').toggleClass('is-acitive');
            $(this).next('.js-nav-toggle-contents').slideToggle();
        });
    }
    /* メニューの折りたたみ */
    if (document.querySelector('.js-fold-menu')) {
        setTimeout(() => {
            const locationPath = window.location.pathname;
            let foldMenuText = locationPath.match(/\/en\//) ? 'Others...' : 'その他...';

            /* MBA単科の英語版と国際学生の方へ日本語以外の言語カテゴリーでは Others... にする */
            if ((locationPath.match(/^\/international-student\/en\//))
                || (locationPath.match(/^\/international-student\/ko\//))
                || (locationPath.match(/^\/international-student\/zh\//))
                || (locationPath.match(/^\/international-student\/tw\//))
                || (locationPath.match(/^\/international-student\/vn\//))
                || (locationPath.match(/^\/international-student\/th\//))
                || (locationPath.match(/^\/program\/essentials\/en\//))) {
                foldMenuText = 'Others...';
            }

            new FoldMenu(document.querySelector('.js-fold-menu > ul'), { foldMenuText, offset: 20 });
        }, 100);

        let hoverTimeout = null;
        let unhoverTimeout = null;
        $('.js-fold-menu').hover(() => {
            clearTimeout(unhoverTimeout);
            $('.js-menu-bg').addClass('active');
            hoverTimeout = setTimeout(() => {
                $('.js-menu-bg').addClass('show');
            }, 300);
        }, () => {
            clearTimeout(hoverTimeout);
            $('.js-menu-bg').removeClass('show');
            unhoverTimeout = setTimeout(() => {
                $('.js-menu-bg').removeClass('active');
            }, 300);
        });

        lazyHover('.js-fold-menu > ul > li', {
            delay: 500,
            timespan: 0,
            switch: true,
        });

        const links = document.querySelectorAll('.js-fold-menu > ul > li > a');
        if ("ontouchstart" in document.documentElement) {
            [].forEach.call(links, (link) => {
                link.addEventListener('click', (e) => {
                    if ($(link).parent('li').hasClass('is-active')) {
                        return;
                    }
                    e.preventDefault();
                });
            });
        }
    }

    // その他…をmouseoverして表示されるメニューでもhx-push-urlを効かせる
    setTimeout(() => {
        const foldMenuToggle = document.querySelector('.js-fold-menu-toggle');
        foldMenuToggle.addEventListener('mouseover', () => {
            const foldMenuList = document.querySelector('.js-fold-menu-list');
            htmx.process(foldMenuList);
        })

    }, 500);
    /**
     * スマホナビゲーション
     */
    $('.js-nav-overlay-btn').click(function callback() {
        const attr = $(this).attr('aria-expanded');
        if (attr === 'true') {
            $(this).attr('aria-expanded', 'false');
            $('.js-nav-overlay-content').removeClass('is-active', 1).removeClass('is-opened', 100);
            $('.js-nav-overlay').removeClass('is-overlay', 100);
        } else {
            $(this).attr('aria-expanded', 'true');
            $('.js-nav-overlay-content').addClass('is-opened', 1).addClass('is-active', 100);
            $('.js-nav-overlay').addClass('is-overlay', 100);
        }
        return false;
    });
    $('.js-nav-overlay-close-btn').click(function () {
        $('.js-nav-overlay-btn').attr('aria-expanded', 'false');
        $('.js-nav-overlay-content').removeClass('is-active', 1).removeClass('is-opened', 100);
        $('.js-nav-overlay').removeClass('is-overlay', 100);
    });
    if (document.querySelector('.js-oc')) {
        new FakeScroll('.js-oc');
    }



    /**
     * mba単科用
     */
    $('.js-classification').change(() => {
        $('.js-contact-contents input, .js-contact-contents select, .js-contact-contents textarea').prop('disabled', true);
        const data = $('.js-classification option:selected').data('detail');
        $('.js-contact-contents').not(`.js-${ data }`).fadeOut();
        $(`.js-${ data }`).fadeIn();
        $(`.js-${ data } input, .js-${ data } select, .js-${ data } textarea`).prop('disabled', false);
    });

});

ACMS.Ready(() => {
    /**
     * ナビゲーションの外部リンク
     */
    const links = document.querySelectorAll('.js-link-match-item');
    [].forEach.call(links, (link) => {
        const href = link.getAttribute('href') || link.getAttribute('data-href');
        const innerLinkPtn = new RegExp('(' + ACMS.Config.domains.replace(/,/g, '|') + ')(:\\d+)*');
        if (!innerLinkPtn.exec(href)) {
            link.insertAdjacentHTML('beforeend', '<i class="fas fa-external-link-alt" style="margin-left: 6px;"></i>');
        }
    });

    /**
     * htmx関連の処理
     */

    addEventListener('htmx:afterSwap', function (evt) {
        // js-lazy-loadなどを効かせる
        ACMS.Dispatch(evt.target);
        // アコーディオンの場合
        if (evt.target.classList.contains('accordion-unit')) {
            const accordionHead = evt.target.querySelector('.js-accordion-head');
            accordionHead.addEventListener('click', (evt) => {
                const accordionTrigger = evt.currentTarget;
                const accordionBody = accordionTrigger.nextElementSibling;
                if (accordionTrigger.classList.contains('open')) {
                    // アコーディオンが開いた状態だったら
                    accordionTrigger.classList.remove('open');
                    accordionTrigger.classList.add('close');
                    accordionBody.classList.remove('open');
                    accordionBody.classList.add('close');
                    accordionBody.setAttribute('aria-hidden', 'true');
                } else {
                    // アコーディオンが閉じた状態だったら
                    accordionTrigger.classList.remove('close');
                    accordionTrigger.classList.add('open');
                    accordionBody.classList.remove('close');
                    accordionBody.classList.add('open');
                    accordionBody.setAttribute('aria-hidden', 'false');
                }
            });
        }
        // main-contentの場合
        if (evt.target.id === "main-content") {
            const hoveredLi = document.querySelector('.p-navigation > ul > li.is-hovered');
            if (hoveredLi) {
                hoveredLi.classList.remove('is-hovered');
                hoveredLi.classList.remove('is-active');
            }
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }

        // モーダルの場合
        if (evt.target.id === "modal-on-movie") {
            // モーダル内からモーダルへのhtmxリンクはmain-contentに変更する
            const modalOnModalLinks = evt.target.querySelectorAll('[hx-target="#modal-on-movie"]');
            modalOnModalLinks.forEach(link => {
                const hrefValue = link.getAttribute('href');
                if (hrefValue) {
                    link.removeAttribute('data-toggle');
                    link.setAttribute("hx-target", "#main-content");
                    link.setAttribute("hx-push-url", hrefValue.replace('?htmx=true', ''));
                    link.setAttribute("hx-get", hrefValue.replace('?htmx=true', '') + '/tpl/include/htmx/entry/body.html');
                    link.setAttribute("hx-swap", "innerHTML");
                    link.addEventListener('click', () => {
                        modalAriaSwitch('hide');
                    });
                }
            });
            const modalBg = document.querySelector('.modal-bg');
            const splitElements = document.querySelector('.p-split__elements');
            if (modalBg) {
                if (window.innerWidth >= 1024) {
                    // PCの場合
                    modalBg.style.width = window.getComputedStyle(splitElements).width;
                }
                modalBg.addEventListener('click', () => {
                    modalAriaSwitch('hide');
                })
            }
            document.querySelector('.body-content-only-wrap').addEventListener('click', function (event) {
                event.stopPropagation();
            });
        }
    });
    window.addEventListener("htmx:historyRestore", function (event) {
        location.reload();
    });

    // モーダル：モーダルのaria属性制御
    // aria属性はモーダル表示にも使用
    // is-modal-loadingはモーダル読み込み時のローダー表示に使用
    function modalAriaSwitch(toDo) {
        const mobalOuters = document.querySelectorAll('.js-modal-outer');
        if (toDo === "hide") {
            // 閉じる動作
            mobalOuters.forEach((mobalOuter) => {
                mobalOuter.setAttribute("aria-hidden", "true");
            });
        } else {
            // 開く動作
            mobalOuters.forEach((mobalOuter) => {
                // mobalOuter.classList.add("is-modal-loading");
                mobalOuter.setAttribute("aria-hidden", "false");
            });
        }
    }

    // モーダル：開閉サマリーリンクの READ MORE ⇄ CLOSE のラベル変換
    function changeGuidLabel(triggerElement, guideText) {
        const guideLabel = triggerElement.querySelector('.c-label-simple-read-more');
        if (guideLabel) {
            if (window.innerWidth >= 1024) {
                guideLabel.classList.remove('fade-in');
                guideLabel.classList.add('fade-out');
                setTimeout(() => {
                    guideLabel.textContent = guideText;
                    guideLabel.classList.remove('fade-out');
                    guideLabel.classList.add('fade-in');
                }, 200);
            } else {
                guideLabel.textContent = guideText;
            }
        }
    }

    // モーダル：開閉サマリーリンクの属性セッティング
    function setAttrMobalTrig(triggerElement, setStatus) {
        if (setStatus === 'show') {
            const href = triggerElement.getAttribute('href');
            if (href) {
                const setHref = href.replace('?htmx=true', '');
                triggerElement.setAttribute('hx-get', setHref + '/tpl/include/htmx/template.html');
                triggerElement.setAttribute('hx-trigger', 'click once');
                triggerElement.dataset.toggle = "show";
            }

        } else if (setStatus === 'hide') {
            triggerElement.setAttribute('hx-get', '/include/htmx/delete.html');
            triggerElement.setAttribute('hx-trigger', 'click once delay:0.4s');
            triggerElement.dataset.toggle = "hide";
        }
    }

    // htmx でのトリガー発生直後
    addEventListener('htmx:confirm', function (event) {
        // モーダル：サマリーまたはモーダル内の×クリック時
        const toDo = event.target.dataset.toggle;
        if (toDo) {
            // モーダル：モーダルのaria属性を変更
            modalAriaSwitch(toDo);
        }
    });

    // htmx での AJAX onload 終了後
    addEventListener('htmx:afterOnLoad', function (evt) {
        // ロード時と共通の初期化
        initContent();

        // モーダル：モーダル関連変数定義
        const mobalOuters = document.querySelectorAll('.js-modal-outer');
        const triggerElement = evt.target;
        const triggerElementDataToggle = triggerElement.dataset.toggle;

        // モーダル：すでに開いているエントリーモーダルを閉じる
        const oldCurrentElement = document.querySelector('.htmx-current');
        if (oldCurrentElement) {
            changeGuidLabel(oldCurrentElement, "READ MORE");
            setAttrMobalTrig(oldCurrentElement, 'show');
            oldCurrentElement.classList.remove('htmx-current');
        }

        if (triggerElementDataToggle === "show") {
            // モーダル：ラベルが READ MORE になっているサマリーをクリックした時
            changeGuidLabel(triggerElement, "CLOSE");
            setAttrMobalTrig(triggerElement, 'hide');
            triggerElement.classList.add('htmx-current');
        } else if (triggerElementDataToggle === "hide") {
            // モーダル：ラベルが CLOSE になっているサマリーをクリックした時
            changeGuidLabel(triggerElement, "READ MORE");
            setAttrMobalTrig(triggerElement, 'show');
        } else if (!(triggerElement.classList.contains('js-modal-outer'))) {
            // モーダル：モーダル操作用ボタン以外でhtmxによるロードが行われた時
            // モーダルに中身は入ったままで、モーダルのaria属性とモーダルの中身が入っているフラグを、モーダルが閉じている状態と同じにする。
            modalAriaSwitch('hide');
            document.querySelector('#modal-on-movie').classList.remove('is-content');
        }

        // モーダル：モーダル読み込み後はローダーを非表示
        // mobalOuters.forEach((mobalOuter) => {
        //     mobalOuter.classList.remove("is-modal-loading");
        // });

        htmx.process(document.body);
    });
});
